import React from 'react';
import { FaFilter } from 'react-icons/fa'
import Select from '../../Select';

import { Container } from './styles';

function MissionFilter() {
  return (
    <Container>
      <FaFilter color="rgb(3, 191, 202)" size={24} />
      <Select name="Habilidades" type="skill" />
      <Select name="Status" type="status"/>
    </Container>
  );
}

export default MissionFilter;